// TODO: Maybe we need a concept to have same widgets with different props.
//       But for now we stick with simple static mapping only.
import type {
  WidgetConfigEntry,
  WidgetPropsType,
} from '@agentselly/immodossier-shared';

export function makeDynamicConfigWidgets(widgets: WidgetConfigEntry[]) {
  return (widgetProps: WidgetPropsType = {}) => {
    if (!widgetProps) {
      return widgets;
    }

    return widgets
      .filter((widget) => !widgetProps[widget.name]?.hidden)
      .map((widget): WidgetConfigEntry => {
        const widgetName = widget.name;

        const staticProps = widget.props || {};
        const dynamicProps = widgetProps[widgetName] || {};

        return {
          ...widget,
          props: {
            ...staticProps,
            ...dynamicProps,
          },
        };
      });
  };
}
